var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partners"},[_c('g-hero',{attrs:{"content":_vm.content.hero}}),_c('g-duo',{attrs:{"content":_vm.content.intro}}),_c('members-grid',{attrs:{"content":{
      title: 'Our <strong>partners</strong>',
      items: _vm.content.partners,
    }}}),(_vm.content.footerCtas)?_c('g-ctas',{attrs:{"content":_vm.content.footerCtas}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }